import { useEffect, useRef, useState } from 'react';

export const useTimer = () => {
    const [timeLeft, setTimeLeft] = useState(0);
    const [timerActive, setTimerActive] = useState(false);
    const totalTimeRef = useRef(0);
    const startTimeRef = useRef(null);
    const rafRef = useRef(null);

    const update = () => {
        if (!startTimeRef.current) return;

        const now = performance.now();
        const elapsed = (now - startTimeRef.current) / 1000; // seconds
        const remaining = Math.max(0, totalTimeRef.current - elapsed);
        setTimeLeft(remaining);

        if (remaining > 0) {
            rafRef.current = requestAnimationFrame(update);
        } else {
            setTimerActive(false);
        }
    };

    const startTimer = (minutes) => {
        const totalSeconds = minutes * 60;
        totalTimeRef.current = totalSeconds;
        setTimeLeft(totalSeconds);
        startTimeRef.current = performance.now();
        setTimerActive(true);
        cancelAnimationFrame(rafRef.current);
        rafRef.current = requestAnimationFrame(update);
    };

    const stopTimer = () => {
        cancelAnimationFrame(rafRef.current);
        setTimerActive(false);
        setTimeLeft(0);
    };

    const formatTime = (rawSeconds) => {
        const seconds = Math.ceil(rawSeconds); // round up for display
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs.toString().padStart(2, '0')}`;
    };

    useEffect(() => {
        return () => cancelAnimationFrame(rafRef.current);
    }, []);

    return {
        timeLeft,
        timerActive,
        startTimer,
        stopTimer,
        formatTime,
        totalTime: totalTimeRef.current
    };
};